import { Divider } from '@jobber/components/Divider';
import { Heading } from '@jobber/components/Heading';
import { checkStatus, formatDateTimeDay, getCompleteAddress } from '../../components/Common/Validations';
import TableTagSVG from './TableTagSVG';

const useTableColumns = () => [
  {
    accessorKey: 'name',
    header: 'Name',
    filterKey: 'PRIMARY_NAME',
    cell: ({ row, getValue }) => {
      const tags = (row.original.tags && row.original.tags.length > 0)
        ? row.original.tags
        : "";
      return (
        <>
          <Heading level={5}>{getValue()}</Heading>
          <p style={{ color: 'var(--muted)' }}>{row.original.secondaryName}</p>
          {tags && tags.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '4px', marginTop: '0.5rem' }}>
              {tags.map((t, index) => (
                <TableTagSVG key={index} text={t.label} />
              ))}
            </div>
          )}
        </>
      );
    },
  },
  {
    accessorKey: 'address',
    header: 'Address',
    cell: ({ row }) => (
      <>
        {row.original.clientProperties &&
          row.original.clientProperties.length > 0 ? (
          row.original.clientProperties.map((c, index, array) => (
            <div key={index}>
              {getCompleteAddress(c)}
              {index !== array.length - 1 && <Divider direction="horizontal" />}
            </div>
          ))
        ) : (
          <div>0 Properties</div>
        )}
      </>
    ),
  },
  {
    accessorKey: 'email',
    header: 'Email',
    cell: ({ row }) => (
      <p>
        {row.original.email?.map(e => e.address).join(' / ')}
      </p>
    ),
  },
  {
    accessorKey: 'phone',
    header: 'Phone no.',
    cell: ({ row }) => (
      <p>
        {row.original.phones?.map(p => p.friendly).join(' / ')}
      </p>
    ),
  },
  {
    accessorKey: 'companyName',
    header: 'Company Name',
    cell: ({ getValue }) => (
      <p>
        {getValue() || ''}
      </p>
    ),
  },
  {
    accessorKey: 'properties',
    header: 'Properties',
    cell: ({ row }) => (
      <p>
        {row.original.clientProperties?.length || 0}
      </p>
    ),
  },
  {
    accessorKey: 'status',
    header: 'Status',
    cell: ({ row }) => (
      <p>
        {checkStatus(row.original)}
      </p>
    ),
  },
  {
    accessorKey: 'activity',
    header: 'Activity',
    filterKey: 'UPDATED_AT',
    cell: ({ row }) => (
      <p>
        {formatDateTimeDay(row.original.updatedAt)}
      </p>
    ),
  },
];

export default useTableColumns;
